import { render, staticRenderFns } from "./FiltersDemo.vue?vue&type=template&id=0985907a&"
import script from "./FiltersDemo.vue?vue&type=script&lang=js&"
export * from "./FiltersDemo.vue?vue&type=script&lang=js&"
import style0 from "./FiltersDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports